import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import { useParams, withRouter } from 'react-router';
import SuspicionEditService from '../service/SuspicionEditService';

const config = data => {
	return {
		key: 'suspicionEditForm',
		text: 'Suspicion',
		topic: 'suspicion',
		title: item => (item && item.nev) || 'Új',
		service: SuspicionEditService,
		fields: initData => {
			const fields = [
				{
					key: 'name',
					text: 'Name',
					component: EditFormTextField
				},
				{
					key: 'timeLimit',
					text: 'Time limit',
					component: EditFormTextField
				},
				{
					key: 'countLimit',
					text: 'Count limit',
					component: EditFormTextField
				}
			];

			return fields;
		}
	};
};

function SuspicionEditForm() {
	const { id, tabKey } = useParams();
	const myConfig = config({ id });
	return <EditFormPage config={myConfig} startTabValue={tabKey} />;
}

export default withRouter(SuspicionEditForm);
